// extracted by mini-css-extract-plugin
export default {"productGallery":"dN-z","inQuickShop":"eN-z"};